import { useState, useEffect } from "react";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/contact`).then(r => setContacts(r.data)).catch(() => {});
  }, []);

  const filtered = contacts.filter(c =>
    !search || c.name.toLowerCase().includes(search.toLowerCase()) || c.email.toLowerCase().includes(search.toLowerCase())
  );

  const exportCSV = () => {
    const header = "Name,Email,Phone,Message,Date,Status\n";
    const rows = contacts.map(c => `"${c.name}","${c.email}","${c.phone || ""}","${c.message.replace(/"/g, '""')}","${new Date(c.created_at).toLocaleDateString()}","${c.status}"`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `paradigm-contacts-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
    URL.revokeObjectURL(url);
    toast.success("Contacts exported!");
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem", flexWrap: "wrap", gap: ".75rem" }}>
        <p style={{ fontSize: ".85rem", color: "#6B7280", margin: 0 }}>{contacts.length} total contacts</p>
        <div style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
          <div style={{ position: "relative" }}>
            <i className="fas fa-search" style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#9CA3AF", fontSize: ".75rem" }} />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search name or email..." style={{ padding: ".4rem .7rem .4rem 2rem", border: "1px solid #D1D5DB", borderRadius: 6, fontSize: ".82rem", width: 220 }} />
          </div>
          <button onClick={exportCSV} style={{ display: "flex", alignItems: "center", gap: ".4rem", padding: ".5rem 1rem", borderRadius: 8, border: "1px solid #D1D5DB", background: "#fff", color: "#374151", cursor: "pointer", fontSize: ".82rem", fontWeight: 500 }}>
            <i className="fas fa-download" /> Export CSV
          </button>
        </div>
      </div>

      <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 1px 3px rgba(0,0,0,.06)", overflow: "hidden" }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "3rem", color: "#9CA3AF" }}>
            <i className="fas fa-address-book" style={{ fontSize: "2rem", marginBottom: ".5rem", display: "block" }} />
            <p>{search ? "No contacts match your search" : "No contact submissions yet"}</p>
          </div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #E5E7EB", background: "#F9FAFB" }}>
                <th style={{ textAlign: "left", padding: ".7rem 1rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase", letterSpacing: ".05em" }}>Name</th>
                <th style={{ textAlign: "left", padding: ".7rem .5rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase" }}>Email</th>
                <th style={{ textAlign: "left", padding: ".7rem .5rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase" }}>Phone</th>
                <th style={{ textAlign: "left", padding: ".7rem .5rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase" }}>Date</th>
                <th style={{ textAlign: "left", padding: ".7rem .5rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase" }}>Status</th>
                <th style={{ textAlign: "right", padding: ".7rem 1rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280" }}></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(c => (
                <tr key={c.id} style={{ borderBottom: "1px solid #F3F4F6", cursor: "pointer" }} onClick={() => setSelected(c)}>
                  <td style={{ padding: ".7rem 1rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: ".6rem" }}>
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg, #EC4899, #F97316)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: ".7rem", fontWeight: 700, flexShrink: 0 }}>
                        {c.name?.charAt(0)?.toUpperCase() || "?"}
                      </div>
                      <span style={{ fontWeight: 600, color: "#1F2937", fontSize: ".85rem" }}>{c.name}</span>
                    </div>
                  </td>
                  <td style={{ padding: ".7rem .5rem", color: "#6B7280", fontSize: ".82rem" }}>{c.email}</td>
                  <td style={{ padding: ".7rem .5rem", color: "#6B7280", fontSize: ".82rem" }}>{c.phone || "—"}</td>
                  <td style={{ padding: ".7rem .5rem", color: "#9CA3AF", fontSize: ".82rem" }}>{new Date(c.created_at).toLocaleDateString()}</td>
                  <td style={{ padding: ".7rem .5rem" }}>
                    <span style={{ padding: ".15rem .5rem", borderRadius: 50, fontSize: ".7rem", fontWeight: 600, background: c.status === "new" ? "rgba(59,130,246,.1)" : "rgba(16,185,129,.1)", color: c.status === "new" ? "#3B82F6" : "#059669" }}>
                      {c.status === "new" ? "New" : "Contacted"}
                    </span>
                  </td>
                  <td style={{ padding: ".7rem 1rem", textAlign: "right" }}>
                    <button style={{ background: "none", border: "none", color: "#9CA3AF", cursor: "pointer" }}><i className="fas fa-chevron-right" /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Detail Modal */}
      {selected && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 200 }} onClick={() => setSelected(null)}>
          <div style={{ background: "#fff", borderRadius: 16, padding: "2rem", maxWidth: 500, width: "90%", maxHeight: "80vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "1.5rem" }}>
              <div>
                <h3 style={{ fontSize: "1.2rem", fontWeight: 700, color: "#1F2937", margin: "0 0 .25rem" }}>{selected.name}</h3>
                <p style={{ fontSize: ".85rem", color: "#EC4899", margin: 0 }}>{selected.email}</p>
              </div>
              <button onClick={() => setSelected(null)} style={{ background: "none", border: "none", color: "#9CA3AF", cursor: "pointer", fontSize: "1.1rem" }}><i className="fas fa-times" /></button>
            </div>
            {selected.phone && <div style={{ display: "flex", alignItems: "center", gap: ".5rem", marginBottom: ".75rem", fontSize: ".85rem", color: "#6B7280" }}><i className="fas fa-phone" style={{ color: "#EC4899", fontSize: ".75rem" }} /> {selected.phone}</div>}
            <div style={{ display: "flex", alignItems: "center", gap: ".5rem", marginBottom: "1rem", fontSize: ".82rem", color: "#9CA3AF" }}><i className="fas fa-calendar" style={{ fontSize: ".75rem" }} /> {new Date(selected.created_at).toLocaleString()}</div>
            <div style={{ background: "#F9FAFB", borderRadius: 8, padding: "1rem", marginBottom: "1rem" }}>
              <p style={{ fontSize: ".85rem", fontWeight: 600, color: "#374151", margin: "0 0 .4rem" }}>Message</p>
              <p style={{ color: "#4B5563", fontSize: ".9rem", margin: 0, lineHeight: 1.6 }}>{selected.message}</p>
            </div>
            <div style={{ display: "flex", gap: ".5rem" }}>
              <a href={`mailto:${selected.email}`} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: ".4rem", padding: ".6rem", borderRadius: 8, background: "linear-gradient(135deg, #EC4899, #F97316)", color: "#fff", fontSize: ".82rem", fontWeight: 600, textDecoration: "none" }}>
                <i className="fas fa-reply" /> Reply
              </a>
              {selected.phone && (
                <a href={`tel:${selected.phone}`} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: ".4rem", padding: ".6rem", borderRadius: 8, border: "1px solid #D1D5DB", color: "#374151", fontSize: ".82rem", fontWeight: 600, textDecoration: "none" }}>
                  <i className="fas fa-phone" /> Call
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
